import { render } from "./DashBoardContent.vue?vue&type=template&id=14039f5f"
import script from "./DashBoardContent.vue?vue&type=script&lang=js"
export * from "./DashBoardContent.vue?vue&type=script&lang=js"
script.render = render

export default script